import { CollapsibleBlock, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { ButtonInternalLink } from "@src/appV2/redesign/components/ButtonInternalLink";
import { uniqueId } from "lodash";

import { type ConsequenceType } from "../Activity/ConsequencePill";
import { ActivityItem } from "../Activity/Item";

export interface AdjustmentsSectionItem {
  title: string;
  consequence: number | "Instant restriction";
  consequenceType: ConsequenceType;
  multiplier?: number;
}

export interface AdjustmentsSectionProps {
  title: string;
  description?: string;
  callout?: React.ReactNode;
  items: AdjustmentsSectionItem[];
  expanded: boolean;
  onClick: () => void;
}

export function AdjustmentsSection(props: AdjustmentsSectionProps) {
  const { title, description, items, callout, expanded, onClick } = props;

  return (
    <Stack paddingTop={6} spacing={6}>
      <CollapsibleBlock
        title={<Text variant="h5">{title}</Text>}
        expanded={expanded}
        LinkComponent={ButtonInternalLink}
        onChange={onClick}
      >
        <Stack direction="column" spacing={3} padding={3}>
          {isDefined(description) && (
            <Text variant="body2" color={(theme) => theme.palette.grey[600]}>
              {description}
            </Text>
          )}
        </Stack>
        <Stack direction="column" spacing={5}>
          {items.map((item) => {
            const { title, consequence, consequenceType, multiplier } = item;

            return (
              <ActivityItem
                key={uniqueId("adjustment-section-")}
                label={title}
                consequence={consequence}
                consequenceType={consequenceType}
                multiplier={multiplier}
              />
            );
          })}
          {callout}
        </Stack>
      </CollapsibleBlock>
    </Stack>
  );
}
